// @flow

import { AccordionCard, Text } from '@boi/core/lib';
import { faDownload } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { format } from 'date-fns';
import React, { useState } from 'react';

import { GET_HOME_DOCUMENT } from '../../../constants/home';
import type {
  AppliedDocument,
  AppliedDocumentGroup
} from '../../../types/Home/Api';
import { getDownloadLink } from '../../../utils/utils';

type Props = {
  documentsGroup: AppliedDocumentGroup,
  className: string,
  expanded: boolean
};

const DocumentsCard = ({ documentsGroup, className, expanded }: Props) => {
  const { date, business_process, documents } = documentsGroup;

  const [isExpanded, setIsExpanded] = useState(expanded);

  const CustomerHeader = () => {
    return (
      <div className="custom-header">
        <div className="custom-header-card">
          <Text align="left">{cardTitle()}</Text>
        </div>
        <div className="custom-header-card">
          <Text align="left">{format(date, 'DD/MM/YYYY')}</Text>
        </div>
      </div>
    );
  };

  const cardTitle = (): string => {
    switch (business_process) {
      case 'RENEWAL_CONFIRMATION':
        return 'Renewed Policy Documents';
      case 'LAPSE':
        return 'Lapse';
      default:
        return 'Policy Documents';
    }
  };

  return (
    <AccordionCard
      id="accordionCard"
      label={cardTitle()}
      status="none"
      labelStyle="black"
      childContainerClass={`${className}__noPaddingAccordion`}
      customLabelClass={`${className}__accordionLabel`}
      isOnState={isExpanded}
      cardAlignment={false}
      customHeader={<CustomerHeader />}
      handleToggle={() => setIsExpanded((exp: boolean) => !exp)}
    >
      {documents.map((document: AppliedDocument, index: number) => {
        return (
          <div
            className={`${className}__linksContainer`}
            key={`travel_document_${index}`}
          >
            <FontAwesomeIcon
              className={`${className}__linkIcon`}
              icon={faDownload}
              onClick={(e: SyntheticMouseEvent<HTMLElement>) => {
                getDownloadLink(
                  e,
                  document.document_id,
                  document.display_name,
                  GET_HOME_DOCUMENT
                );
              }}
            />
            <a
              href="#"
              className={`${className}__link`}
              onClick={(e: SyntheticMouseEvent<HTMLElement>) => {
                getDownloadLink(
                  e,
                  document.document_id,
                  document.display_name,
                  GET_HOME_DOCUMENT
                );
              }}
            >
              {document.display_name}
            </a>
          </div>
        );
      })}
    </AccordionCard>
  );
};

export default DocumentsCard;
